import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan, ioCallUserEnter } from "./api";
import { emsList, emsGraphData, recData,batteryMetricsEndpoint } from "../utility/Constants";
import {
  calCriticalLoad,
  calAirconLoad,
  graphObj,
  getPowerObj,
} from "../utility/defined-methods";
import { getUser, removeUser } from "../utility/preferences";
import { saveAs } from "file-saver";
import moment from "moment";
let now = new Date();
const slice = createSlice({
  name: "emslist",
  initialState: {
    user: getUser(),
    emsArray: [],
    loading: false,
    userID: {},
    eachEMSData: {},
    cellEMSData: {},
    emsName: "#",
    emsPowerGraph: {
      emsPowerArray: [],
      selectedTime: {},
    },
    catList: [
      "BMS",
      "INVERTER",
      "RECTIFIER",
    ],
    packetData: [],
    to: "",
    from: "",
    cat: "",
  },
  reducers: {
    emsListRequested: (emsList, action) => {
      emsList.loading = true;
    },
    emsListReceived: (emsList, action) => {
      let list = action.payload;
      emsList.loading = false;
      emsList.emsArray = list["emsList"];
    },
    emsListRequestFailed: (emsList, action) => (emsList.loading = false),
    graphDataRec: (emsList, action) => {
      let { emsName, data } = action.payload;

      emsList.emsPowerGraph = {
        emsPowerArray: [],
        selectedTime: {},
      };
      emsList.loading = false;
      if (data != undefined && data.length > 1) {
        let { emsPowerArray, selectedTime } = emsList.emsPowerGraph;
        // emsPowerArray = [];
        // selectedTime = {};
        // let _emsPowerArray = [];
        let _emsPowerArray = emsPowerArray;
        let _selectedTime = selectedTime;
        data.reverse().forEach((element) => {
          _emsPowerArray.push(graphObj(element, emsName, element["date"]));
        });
        emsPowerArray = _emsPowerArray;
        console.log("emsPowerArray: =====>", emsPowerArray.length);
        let length = _emsPowerArray.length - 1;
        let _max = _emsPowerArray[length]["x"];
        let _end = _emsPowerArray[length]["x"];
        let _start = _emsPowerArray[0]["x"];
        let _min = _emsPowerArray[0]["x"];
        _selectedTime = {
          min: _min,
          max: _max,
          start: _start,
          end: _end,
          selectedTime: null,
        };
        emsList.emsPowerGraph.selectedTime = _selectedTime;
        emsList.emsName = emsName;
      }
    },
    userEntryRequest: (emsList, action) => {
      emsList.userID = action.payload;
    },
    specificGraphPacket: (emsList, action) => {
      let { emsID, emsPacket } = action.payload;
      let power = getPowerObj(emsPacket);
      if (emsPacket["PacketType"] == 1) {
        emsList.eachEMSData = emsPacket;
      }
      if (emsPacket["PacketType"] == 1 && power["x"] != null && emsID !== "#") {
        let _emsPowerArray = emsList.emsPowerGraph.emsPowerArray;
        if (_emsPowerArray.length > 0) {
          let _end = +power["x"];
          let _max = +power["x"];
          _emsPowerArray.push(getPowerObj(emsPacket));
          emsList.emsPowerGraph.emsPowerArray = _emsPowerArray;
          emsList.emsPowerGraph.selectedTime.end = _end;
          emsList.emsPowerGraph.selectedTime.max = _max;
        }
      }
      if (emsPacket["PacketType"] == 2) {
        emsList.cellEMSData = emsPacket;
      }
    },
    setPwrGraphSelTime: (emsList, action) => {
      let { selectedTime, start, end } = action.payload;
      emsList.emsPowerGraph.selectedTime.selectedTime = selectedTime;
      emsList.emsPowerGraph.selectedTime.start = start;
      emsList.emsPowerGraph.selectedTime.end = end;
    },
    setEMSPacket: (emsList, action) => {
      let { PacketType } = action.payload;
      if (PacketType == 1) {
        emsList.eachEMSData = action.payload;
      }
    },
    setEMSName: (emsList, action) => {
      let emsName = action.payload;
      emsList.emsName = emsName;
    
      if (emsName == "#") {
        emsList.emsPowerGraph = {
          emsPowerArray: [],
          selectedTime: {},
        };
      }
    },
    packetDataRequest: (emsList, action) => {
      emsList.loading = false;
      let payload = action.payload;
      emsList.packetData = payload["data"];
      console.log("packetData", emsList.packetData);
      DownloadJsonFile(emsList.packetData);
      
    },
    batteryMetricsRequested: (state) => {
      state.loading = true;
    },
    batteryMetricsReceived: (state, action) => {
      state.loading = false;
      state.batteryMetrics = action.payload;
    },
    batteryMetricsRequestFailed: (state) => {
      state.loading = false;
    },
  },
});

let DownloadJsonFile = (packetData) => {
  
    const json = JSON.stringify(packetData);
    const blob = new Blob([json], { type: "application/json" });
    var date = moment(new Date()).format("YYYY_MM_DD-HH_mm_ss");
    var fileName = "emsreport" + date + ".json";
    saveAs(blob, fileName);
  
};

export default slice.reducer;

export const {
  userEntryRequest,
  setEMSName,
  setEMSPacket,
  specificGraphPacket,
  setPwrGraphSelTime,
} = slice.actions;

export const loadEmsList = () => (dispatch) => {
  const { emsListRequested, emsListReceived, emsListRequestFailed } =
    slice.actions;

  return dispatch(
    apiCallBegan({
      url: emsList,
      method: "POST",
      onStart: emsListRequested.type,
      onSuccess: emsListReceived.type,
      onError: emsListRequestFailed.type,
    })
  );
};

const sendEmsDetail = (data) => {
  return (dispatch) => {
    dispatch();
  };
};
export const callEmsGraphData = (data) => {
  return (dispatch) => {
    const { emsListRequested, graphDataRec, emsListRequestFailed } =
      slice.actions;

    return dispatch(
      apiCallBegan({
        url: emsGraphData,
        method: "POST",
        onStart: emsListRequested.type,
        onSuccess: graphDataRec.type,
        onError: emsListRequestFailed.type,
        data: data,
      })
    );
  };
};

export const callPacketData = (data) => {
  return (dispatch) => {
    const { emsListRequested, packetDataRequest, emsListRequestFailed } =
      slice.actions;

    return dispatch(
      apiCallBegan({
        url: recData,
        method: "POST",
        onStart: emsListRequested.type,
        onSuccess: packetDataRequest.type,
        onError: emsListRequestFailed.type,
        data: data,
      })
    );
  };
};

export const fetchBatteryMetrics = (data) => {
  return (dispatch) => {
    const { batteryMetricsRequested, batteryMetricsReceived, batteryMetricsRequestFailed } = slice.actions;

    return dispatch(
      apiCallBegan({
        url: batteryMetricsEndpoint,
        method: "POST",
        onStart: batteryMetricsRequested.type,
        onSuccess: batteryMetricsReceived.type,
        onError: batteryMetricsRequestFailed.type,
        data
      })
    );
  };
};
